module.exports = __webpack_public_path__ + "img/trasporto.556c6604.png";